<template>
  <v-container fluid>
    <v-row>
      <v-col class="text-center" cols="12">
        <h1 :class="headerTitleClass" class="synthesis-brand-lightest-blue--text mb-8">
          Our success stories
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="synthesis-ui-blue-02 pa-4 pa-md-8 pa-lg-16 synthesis-section-border-radius" flat>
          <v-container class="text-center" fluid>
            <v-row>

              <v-col cols="12">
                <div class="video-container-responsive">
                  <div style="position: relative; width: 100%; padding-top: 56.25%;">
                    <iframe style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: 0;"
                      src="https://www.youtube.com/embed/AanyGWuNax8?controls=1&showinfo=0&modestbranding=1&rel=0"
                      frameborder="0" allow="fullscreen" allowfullscreen></iframe>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="synthesis-ui-blue-02 pa-0 pa-md-8 pa-lg-16 py-0 py-md-0 py-lg-0 synthesis-section-border-radius"
          flat height="550">
          <v-img height="550" src="/img/bg/card-bg.png">
            <v-container class="fill-height text-center align-center justify-center" fluid>
              <v-row>
                <v-col cols="12">
                  <div class="d-inline-block" style="max-width: 780px;">
                    <h1 :class="headerTitleClass" class="synthesis-brand-lightest-blue--text">
                      Get started today and secure your business.
                    </h1>

                    <h2 :class="headerSubTitleClass" class="synthesis-brand-lightest-blue--text py-6">
                      Speak to a member of our team today to get started with Synthesis and be confident you are on top
                      of your risk during both calm periods and market crises!
                    </h2>
                  </div>
                </v-col>

                <v-col cols="12">
                  <v-btn class="synthesis-brand-dark-blue--text" color="white" depressed height="42" width="110"
                    :to="{ name: 'ContactUs' }" v-text="$t('Common.Button.ContactUs')" />
                </v-col>
              </v-row>
            </v-container>
          </v-img>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import dialogVisible from '@/mixins/dialog/dialogVisible'
import dialogData from '@/mixins/dialog/dialogData'
import ContactModel from '@/api/models/contact/ContactModel'
import i18nRouteMeta from '@/mixins/i18n/i18nRouteMeta'
import CssClassFontSizes from '@/mixins/cssClassFontSizes'

export default {
  name: 'CaseStudies',
  components: {},
  directives: {},
  mixins: [i18nRouteMeta, CssClassFontSizes, dialogVisible, dialogData],
  props: {},
  enums: {},
  dataModel: ContactModel,
  data () {
    return {
      errorMessage: ''
    }
  },
  computed: {},
  watch: {
    isVisible () {
      this.errorMessage = ''
    }
  },
  beforeCreate () { },
  created () { },
  beforeMount () { },
  mounted () { },
  beforeUpdate () { },
  updated () { },
  beforeDestroy () { },
  destroyed () { },
  methods: {}
}
</script>

<style scoped>
.video-container-responsive {
  max-width: 700px;
  margin: 0 auto;
}

@media (min-width: 960px) {
  .video-container-responsive {
    max-width: 900px;
  }
}

@media (min-width: 1264px) {
  .video-container-responsive {
    max-width: 1000px;
  }
}

@media (min-width: 1904px) {
  .video-container-responsive {
    max-width: 1200px;
  }
}
</style>
